import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ActionText from '../../../../../../../components/ActionText'
import ManageTotalPrice from './ManageTotalPrice'

import { createNewProduct, getMaxOrderAndDiscount } from '../helpers/addProduct'

import { MEDIA_PRODUCTS } from '../../../fields'

import useStyles from './styles'

const FooterSummary = ({
  formik,
  disableProductAdd,
  allowEdit,
  allowAutoSave,
  editProductId,
  isAmendment,
  isAmendProcess,
  hasReachData,
  handleTotalEdit
}) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { values, setFieldValue } = formik

  const handleAddNewProductRow = useCallback(() => {
    const { maxOrder, discount } = getMaxOrderAndDiscount(values[MEDIA_PRODUCTS])
    const newProductValues = createNewProduct(maxOrder + 1, discount)

    setFieldValue(MEDIA_PRODUCTS, values[MEDIA_PRODUCTS].concat(newProductValues))
  }, [values, setFieldValue])

  const products = values[MEDIA_PRODUCTS]
  const hasAtLeastOneProduct = useMemo(() => {
    const hasProducts = products.length > 0
    return hasProducts && products.some(product => product.data)
  }, [products])

  return (
    <div className={classes.footerContent}>
      {allowEdit && (
        <ActionText
          onClick={handleAddNewProductRow}
          isDisabled={disableProductAdd}
          className={classes.newProductButton}
          isDark
        >
          {t('+ Add product')}
        </ActionText>
      )}
      {hasAtLeastOneProduct && (
        <ManageTotalPrice
          formik={formik}
          allowEdit={allowEdit}
          isAmendment={isAmendment}
          isAmendProcess={isAmendProcess}
          editProductId={editProductId}
          hasReachData={hasReachData}
          handleTotalEdit={handleTotalEdit}
          allowAutoSave={allowAutoSave}
        />
      )}
    </div>
  )
}

FooterSummary.propTypes = {
  formik: PropTypes.object,
  disableProductAdd: PropTypes.bool,
  isAmendment: PropTypes.bool,
  isAmendProcess: PropTypes.bool,
  editProductId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleTotalEdit: PropTypes.func,
  hasReachData: PropTypes.bool,
  allowEdit: PropTypes.bool,
  allowAutoSave: PropTypes.bool
}

export default FooterSummary
